import React from 'react'

function Avviso() {
	return (
		<>
			{new Date() < new Date('2025/08/26') && (
				<div className="avviso">
					<div className="titolo_avviso">
						<b>Pausa estiva</b>
						{/* <b>Pausa Natalizia</b> */}
						{/* <b>Il catalogo edizione 2022 sta per terminare.</b> */}
					</div>
					<div className="testo_avviso">
						Le spedizioni dei premi saranno interrotte dal <b>04/08/2025</b> al <b>24/08/2025</b> inclusi e riprenderanno regolarmente a partire dal <b>25/08/2025</b>.
						<br />
						Tutti i prodotti ordinati dal <b>04/08/2025</b> saranno quindi regolarmente spediti dal <b>25/08/2025</b>.
					</div>
				</div>
			)}
		</>
	)
}

export default Avviso
